// eslint-disable-next-line no-unused-vars
import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModuleRoute from 'holocron-module-route';
// eslint-disable-next-line no-unused-vars
import { Route } from '@americanexpress/one-app-router';
import Error404Page from './components/Common/Error404Page';
import ErrorMessage from './components/Common/ErrorMessage';

const childRoutes = () => [
  <ModuleRoute
    key="axp-secure-file-express-portal"
    path="/"
    moduleName="axp-secure-file-express-portal"
    hasChildRoutes={true}
  />,
  <Route key="error-paths" path="error" component={ErrorMessage} />,
  <Route key="error404-paths" path="*" component={Error404Page} />,
];

export default childRoutes;
